import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ManageFolders from "../../../ClassSettings/routes/ManageFolders";
export default store => ({
  path: "module",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "course-module" */ "../../../ClassSettings/components"
        ),
        import(
          /* webpackChunkName: "course-module" */ "../../../ClassSettings/modules/ClassSettingsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "module",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ManageFolders(store)],
});
